export class FMAllRequestsModel {
  id: number;
  requestId: number;
  requestorId: number;
  requestorName: string;
  requestStatusName: string;
  requestNumber: string;
  requstStatusId: number;
  fmRequestType: string;
  companyName: string;
  expiredStatus: string;
}




// WEBPACK FOOTER //
// ./src/app/core/models/fm-all-requests.ts